import { isPlatformEnabled } from "@common/helpers/organization";
import { useActiveWorkspaceDetails } from "./useActiveWorkspaceDetails";

interface WorkspaceOrganizationAssignments {
    organizationAssignments: ReadonlyArray<{
        organization?: { platformEnabledAt: Date | null };
    }>;
}

export function hasPlatformEnabledOrganization({
    organizationAssignments,
}: WorkspaceOrganizationAssignments): boolean {
    return organizationAssignments.some(
        ({ organization }) =>
            organization !== undefined && isPlatformEnabled(organization),
    );
}

export function useIsActiveWorkspacePlatformEnabled(): boolean {
    const workspaceDetails = useActiveWorkspaceDetails();
    return workspaceDetails
        ? hasPlatformEnabledOrganization(workspaceDetails)
        : false;
}
